import { Component, ViewChild, ElementRef } from "@angular/core";
import { interval, Subscription } from 'rxjs';

import { Debounce } from "lodash-decorators";
import * as _ from 'lodash';
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

import { WioaProgram } from "./models/wioaProgram";
import { TrainingService } from "./services/training.service";


@Component({
  selector: 'training-wioa-list',
  templateUrl: './training-wioa.component.html',
  styleUrls: ['./training-list.component.css'],
  providers: [TrainingService]
})
export class TrainingWioaComponent {

  @ViewChild('confirmWioaModalTemplate', { static: false }) confirmWioaRemovalTemplate: ElementRef;

  selectedWioaProgram: WioaProgram;
  wioaPrograms: Array<any> = [];
  loaded: boolean = false;

  confirmMessage: string = "";
  confirmWioaRemovalModal: BsModalRef;

  timeout: boolean = false;
  subscription: Subscription;

  constructor(private trainingService: TrainingService, private toastr: ToastrService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.loadWioaPrograms();    
  }



  loadWioaPrograms() {
    this.trainingService.getWioaPrograms().subscribe(res => {
      this.wioaPrograms = res;

      this.loaded = true;
    });
  }


  @Debounce(500)
  wioaListChange(e: any) {

    this.wioaPrograms.forEach(c => {
      //update index on obj
      c.index = _.indexOf(this.wioaPrograms, c);

      this.trainingService.updateWioaProgram(c).subscribe(res => {
      },
        error => {
          console.log("Error updating", error, c);
          this.toastr.error("Error updating Wioa Program");
        });
    });
  }

  moveProgramUp(program: WioaProgram) {

    var i = 0;
    i = _.indexOf(this.wioaPrograms, program);

    if (i !== 0) {

      this.wioaPrograms.splice(i--, 0, this.wioaPrograms.splice(i, 1)[0]);

      this.wioaPrograms = [...this.wioaPrograms];
    }

    this.wioaListChange('');
  }

  moveProgramDown(program: WioaProgram) {
    var i = 0;
    i = _.indexOf(this.wioaPrograms, program);
    var max = this.wioaPrograms.length - 1;

    if (i !== max) {
      this.wioaPrograms.splice(i++, 0, this.wioaPrograms.splice(i, 1)[0]);

      this.wioaPrograms = [...this.wioaPrograms];
    }

    this.wioaListChange('');
  }


  removeWioaProgram(program: WioaProgram, confirm: boolean = false) {

    this.selectedWioaProgram = program;
    if (!confirm) {
      this.confirmMessage = "Are you you want to remove " + program.title + " ?";

      this.confirmWioaRemovalModal = this.modalService.show(this.confirmWioaRemovalTemplate);

    } else {

      this.confirmWioaRemovalModal.hide();

      this.trainingService.removeWioaProgram(program.id).subscribe(res => {

        this.wioaPrograms = this.wioaPrograms.filter(f => f.id != program.id);
        this.wioaPrograms = [...this.wioaPrograms];

        //Update List
        this.wioaListChange('');

      }, error => {
        console.log('Error deleting Wioa Program', error, program);
        this.toastr.error("Error removing Wioa Program");
      });
    }
  }

  ngAfterViewInit() {
    const source = interval(30000)
    this.subscription = source.subscribe(val => this.wioaListChange(''));

    this.resetTimeout();
  }

  resetTimeout() {
    this.timeout = false;

    setTimeout(() => {
      this.timeout = true;
    }, 30000);
  }
}
